import $ from "jquery";
import Isotope from "isotope-layout";
import 'isotope-packery';
// npm install isotope-layout
// npm install isotope-packery
import { setIntervalTimes } from "./utils.js";

$(function() {
    $(".bl-joblist").each(function() {
        const $bl = $(this);

        //Init isotope
        const $guttersizer = $bl.find(".guttersizer");
        const $columnsizer = $bl.find(".columnsizer");

        const iso = new Isotope($bl.find(".ctritems").get(0), {
            layoutMode: 'packery',
            itemSelector: ".item",
            percentPosition: true,
            packery: {
                gutter: $guttersizer.get(0),
                columnWidth: $columnsizer.get(0)
            }
        });

        $(window).on("load", function() {
            iso.layout();
        });

        //More button
        $bl.on("click", ".btnmore", function() {
            //close others
            $bl.find(".item").removeClass("expanded");

            //expand clicked item
            const $item = $(this).closest(".item");
            $item.addClass("expanded");
            setIntervalTimes(function() {
                iso.layout();
            }, 50, 5); //fire 5 times (animated .item width results in dynamic height)
        });
    });
});